import { render, staticRenderFns } from "./VisualEditorRow.vue?vue&type=template&id=53a009bb&"
import script from "./VisualEditorRow.vue?vue&type=script&lang=js&"
export * from "./VisualEditorRow.vue?vue&type=script&lang=js&"
import style0 from "./VisualEditorRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports